const initialState = {
  index: [],
  selected: [],
  data: {},
};

const DocumentationCategory = (state = initialState, action) => {
  switch (action.type) {
    case "DOCUMENTATION_CATEGORY_INDEX":
      return { ...state, index: action.payload.index };
    case "DOCUMENTATION_CATEGORY_SELECTED":
      return { ...state, selected: action.payload.selected };
    case "DOCUMENTATION_CATEGORY_DATA":
      return { ...state, data: action.payload.data };
    case "DOCUMENTATION_CATEGORY_RESET":
      return initialState;
    default:
      return state;
  }
};

export default DocumentationCategory;
